import { StoredProcedureScope } from '@cloud-native/workflows-engine'
import { FeatureFlag, useFeatureFlag } from 'app/ui/useFeatureFlag'
import { Workflow, WorkflowListItem } from 'features/workflows/types'
import { isProcedureOutdated } from 'features/workflows/service/common/utils'

export function useApiEnabled(workflow: Workflow | WorkflowListItem) {
  const isFeatureFlagEnabled = useFeatureFlag(FeatureFlag.WorkflowsExport)
  const isProcedureCreated = Boolean(workflow?.config?.procedure?.call)
  return isFeatureFlagEnabled && isProcedureCreated
}

export function isApiOutdated(workflow: Workflow) {
  return isProcedureOutdated(workflow, StoredProcedureScope.Api)
}
